/* ============================================================
   Kaizen Seven — EFW PDP Hero 3A
   Gallery (click-to-advance + segment jump) and AJAX add-to-cart
   wired to the theme's cart drawer via the `cart:refresh` event.
   ============================================================ */
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initGallery(root) {
    var stage = root.querySelector('[data-efw3a-advance]');
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-efw3a-img]'));
    var segments = Array.prototype.slice.call(root.querySelectorAll('[data-efw3a-segment]'));
    var counter = root.querySelector('[data-efw3a-counter]');
    var bar = root.querySelector('.efw3a__gallery-bar');

    if (!stage || images.length === 0) return;

    if (images.length <= 1) {
      if (images[0]) {
        images[0].classList.add('is-active');
      }
      if (bar) {
        bar.style.display = 'none';
      }
      return;
    }

    if (bar) {
      bar.style.display = '';
    }

    var index = 0;

    function render() {
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      segments.forEach(function (seg, i) {
        seg.classList.toggle('is-active', i === index);
        seg.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (counter) {
        counter.textContent = pad(index + 1) + ' / ' + pad(images.length);
      }
    }

    stage.addEventListener('click', function () {
      index = (index + 1) % images.length;
      render();
    });

    segments.forEach(function (seg, i) {
      seg.addEventListener('click', function () {
        index = i;
        render();
      });
    });

    render();
  }

  function initAddToCart(root) {
    var form = root.querySelector('[data-efw3a-form]');
    var button = root.querySelector('[data-efw3a-atc]');
    if (!form || !button || button.disabled) return;

    var labelEl = button.querySelector('[data-efw3a-atc-label]');
    var addedLabel = button.getAttribute('data-added-label') || 'Added';
    var defaultLabel = labelEl ? labelEl.textContent : '';
    var added = false;
    var timer = null;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (added) return;

      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) return;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantInput.value), quantity: 1 }],
          sections: 'cart-drawer'
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed (' + response.status + ')');
          return response.json();
        })
        .then(function (response) {
          if (response.sections && response.sections['cart-drawer']) {
            window.dispatchEvent(
              new window.CustomEvent('cart:refresh', {
                detail: { payload: response.sections['cart-drawer'] }
              })
            );
          }
          added = true;
          if (labelEl) labelEl.textContent = addedLabel;
          clearTimeout(timer);
          timer = setTimeout(function () {
            added = false;
            if (labelEl) labelEl.textContent = defaultLabel;
          }, 1500);
        })
        .catch(function (err) {
          console.error('EFW Hero 3A:', err);
          form.submit();
        });
    });
  }

  function init(root) {
    if (root.dataset.efw3aInit) return;
    root.dataset.efw3aInit = 'true';
    initGallery(root);
    initAddToCart(root);
  }

  function initAll() {
    document.querySelectorAll('[data-efw3a]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init inside the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-efw3a]');
    if (root) init(root);
  });
})();
